import { render, staticRenderFns } from "./UserSettingsBookingFeedback.vue?vue&type=template&id=cac5f672&"
import script from "./UserSettingsBookingFeedback.vue?vue&type=script&lang=js&"
export * from "./UserSettingsBookingFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports